import { KatAlert } from "@amzn/katal-react";
import React from "react";

export const PageNotFoundAlert = (props: { pageId?: string }) => (
    <KatAlert header="Page not found" variant="danger">
        Help content with id <b>{props.pageId}</b> is not defined.
    </KatAlert>
);